import {Component} from '@angular/core';
import {HeaderComponent} from '../../components/header/header.component';
import {Footer} from '../../../core/components/footer/footer';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {NgClass, NgIf} from '@angular/common';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {combineLatest} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-gift-card-confirmation',
  standalone: true,
  imports: [
    HeaderComponent,
    Footer,
    RouterLink,
    NgIf,
    NgClass,
    TranslocoPipe,
  ],
  templateUrl: './gift-card-confirmation.component.html',
  styleUrl: './gift-card-confirmation.component.scss'
})
export class GiftCardConfirmationComponent {
  public status: 'success' | 'failed' = 'success';
  public expectedDeliveryDate: string | null = null;

  public constructor(
    private readonly route: ActivatedRoute,
    private readonly transloco: TranslocoService,
  ) {
    combineLatest([this.route.paramMap, this.route.queryParamMap])
      .pipe(takeUntilDestroyed())
      .subscribe(([params, queryParams]) => {
        const statusParam = (params.get('status') ?? '').toLowerCase();
        this.status = statusParam === 'success' ? 'success' : 'failed';

        const deliveryDateIso = queryParams.get('deliveryDate');
        if (deliveryDateIso) {
          const parsedDate = DateTime.fromISO(deliveryDateIso);
          if (parsedDate.isValid) {
            const locale = this.transloco.getActiveLang() || 'en';
            this.expectedDeliveryDate = parsedDate
              .setLocale(locale)
              .toLocaleString(DateTime.DATE_FULL);
            return;
          }
        }

        this.expectedDeliveryDate = null;
      });
  }

  public get isSuccess(): boolean {
    return this.status === 'success';
  }
}
